import {currencyStringToValue, roundTo, valueToCurrency} from "./helperFunction";


export default function processRevenueCalculation(price, currencyOptions, generalOptions, elementGroup, includingFees) {
    if(includingFees){
        const fees = currencyStringToValue(elementGroup.presaleFee.textContent, currencyOptions, generalOptions) + currencyStringToValue(elementGroup.ticketFee.textContent, currencyOptions, generalOptions);
        let result = roundTo(currencyStringToValue(elementGroup.customerPrice.textContent, currencyOptions, generalOptions) - fees, currencyOptions, generalOptions);
        elementGroup.endPrice.textContent = valueToCurrency(result, currencyOptions, true);
    }else{
        const endPrice = roundTo(price, currencyOptions, generalOptions);
        elementGroup.endPrice.textContent = valueToCurrency(endPrice, currencyOptions, true);
    }
}
